import React, { useState } from 'react';
import '../styles/contact.css';

const contactInfo = [
  {
    icon: '✉',
    title: 'Email',
    value: 'tvcologan@gmail.com',
    href: 'mailto:tvcologan@gmail.com',
  },
  {
    icon: '◎',
    title: 'WhatsApp',
    value: '+34 606 70 10 75',
    href: 'https://wa.me/34606701075',
  },
  {
    icon: '◈',
    title: 'Ubicación',
    value: 'Santa Cruz de Tenerife, España',
    href: null,
  },
];

const Contact = () => {
  const [form, setForm] = useState({ name: '', email: '', company: '', subject: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [sending, setSending] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSending(true);
    setTimeout(() => {
      setSending(false);
      setSubmitted(true);
    }, 900);
  };

  return (
    <div className="contact-page">

      <section className="contact-hero">
        <p className="contact-page-label">CONTACTO</p>
        <h1 className="contact-hero-heading fredoka-400">Hablemos.</h1>
        <p className="contact-hero-sub">
          Cuéntanos tu proyecto y te respondemos a la mayor brevedad posible.
        </p>
      </section>

      <section className="contact-info">
        <div className="contact-info-inner">
          {contactInfo.map((item, i) => (
            <div key={i} className="contact-info-card">
              <span className="contact-info-icon" style={{ fontSize: '2rem' }}>{item.icon}</span>
              <p className="contact-info-title">{item.title}</p>
              {item.href ? (
                <a href={item.href} className="contact-info-value">{item.value}</a>
              ) : (
                <p className="contact-info-value">{item.value}</p>
              )}
            </div>
          ))}
        </div>
      </section>

      <section className="contact-form-section">
        <div className="contact-form-inner">
          <p className="about-section-label" style={{ color: '#7275BB' }}>ENVÍANOS UN MENSAJE</p>
          <h2 className="contact-form-heading fredoka-400">¿En qué podemos ayudarte?</h2>
          <p className="contact-form-sub">Completá el formulario y nos ponemos en contacto.</p>

          {submitted ? (
            <div className="contact-success">
              <span className="contact-success-icon">✓</span>
              <h3 className="contact-success-heading">¡Mensaje enviado!</h3>
              <p className="contact-success-text">Gracias por escribirnos. Te responderemos pronto.</p>
            </div>
          ) : (
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="contact-form-row">
                <div className="contact-form-group">
                  <label className="contact-form-label" htmlFor="name">Nombre</label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    className="contact-form-input"
                    placeholder="Tu nombre"
                    value={form.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="contact-form-group">
                  <label className="contact-form-label" htmlFor="email">Email</label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    className="contact-form-input"
                    placeholder="tu@email.com"
                    value={form.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
              <div className="contact-form-row">
                <div className="contact-form-group">
                  <label className="contact-form-label" htmlFor="company">Empresa <span style={{ opacity: 0.5 }}>(opcional)</span></label>
                  <input
                    id="company"
                    name="company"
                    type="text"
                    className="contact-form-input"
                    placeholder="Nombre de tu empresa"
                    value={form.company}
                    onChange={handleChange}
                  />
                </div>
                <div className="contact-form-group">
                  <label className="contact-form-label" htmlFor="subject">Asunto</label>
                  <input
                    id="subject"
                    name="subject"
                    type="text"
                    className="contact-form-input"
                    placeholder="¿Sobre qué querés hablar?"
                    value={form.subject}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
              <div className="contact-form-group">
                <label className="contact-form-label" htmlFor="message">Mensaje</label>
                <textarea
                  id="message"
                  name="message"
                  className="contact-form-textarea"
                  placeholder="Contanos tu proyecto, idea o consulta..."
                  value={form.message}
                  onChange={handleChange}
                  required
                />
              </div>
              <button type="submit" className="contact-form-submit" disabled={sending}>
                {sending ? 'Enviando...' : 'Enviar mensaje'}
              </button>
            </form>
          )}
        </div>
      </section>

    </div>
  );
};

export default Contact;
